var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgZap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 71,
  height: 71,
  fill: "none",
  viewBox: "0 0 71 71"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4A557F",
  fillRule: "evenodd",
  d: "M39.629 3.765a2.625 2.625 0 0 1 1.56 2.733L38.64 26.881h23.277a2.625 2.625 0 0 1 2.016 4.306l-29.166 35a2.625 2.625 0 0 1-4.622-2.007l2.548-20.382H9.417A2.625 2.625 0 0 1 7.4 39.492l29.167-35a2.625 2.625 0 0 1 3.062-.727M15.02 38.548h20.646a2.625 2.625 0 0 1 2.605 2.95l-1.807 14.45L56.312 32.13H35.667a2.625 2.625 0 0 1-2.605-2.95l1.806-14.45z",
  clipRule: "evenodd"
})));
export default SvgZap;